export enum TabNames {
    "Property Search" = "Property Search",
    "Planning Applications" = "Planning Applications",
    "Planning Appeals" = "Planning Appeals",
    "Weekly Lists" = "Weekly Lists",
    "Enforcement Notices" = "Enforcement Notices",
    "Enforcement Appeals" = "Enforcement Appeals",
    "Building Regulations" = "Building Regulations",
}

export enum RecordDetailsTabNames {
    "Summary" = "Summary",
    "Constraints" = "Constraints",
    "Documents" = "Documents",
    "Map" = "Map",
    "Comments" = "Comments",
    "Consultations" = "Consultations",
}
